import jsonp from 'jsonp';
import { DateTime } from 'luxon';

/* eslint-disable no-plusplus */
export function numberFormat(number) {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(number);
}

export function orderDateFormat(date) {
  return DateTime.fromISO(date)
    .setLocale('en-US')
    .toFormat('LLLL dd yyyy - tt');
}
export function parseSearchResult(filters, result) {
  let filtered = result;
  if (filters.jewelryType) {
    filtered = filtered.filter((item) => !!item.jewelryType);
  }

  if (filters.metal) {
    filtered = filtered.map((item) => ({
      ...item,
      variations: item.variations.filter((v) => !!v.metal),
    }));
    filtered = filtered.filter((f) => f.variations.length > 0);
  }

  if (filters.gem) {
    filtered = filtered.map((item) => ({
      ...item,
      variations: item.variations.filter((v) => !!v.gem),
    }));
    filtered = filtered.filter((f) => f.variations.length > 0);
  }

  return filtered;
}

export function getProductImage({ variations }, variation) {
  if (variation?.image?.formats?.small?.url) {
    return variation?.image?.formats?.small?.url;
  }
  if (variation?.image?.formats?.thumbnail?.url) {
    return variation?.image?.formats?.thumbnail?.url;
  }

  let image = null;

  for (let i = 0; i < variations.length; i++) {
    if (variations[i].image) {
      image = variations[i].image.url;
      break;
    }
  }

  return image;
}

export function newsletterSubscribe({
  email,
  firstName,
  lastName,
  name,
  phone,
  company,
}) {
  const fName = name ? name.split(' ')[0] : firstName;
  const lName = name
    ? name
        .split(' ')
        .slice(1, name.length - 1)
        .join(' ')
    : lastName;

  const endpoint =
    'https://galateausa.us5.list-manage.com/subscribe/post-json?u=3f2a5a03f28085c5515415065&amp;id=072dff93a0';
  const URL = `${endpoint}&EMAIL=${email}&FNAME=${fName}&LNAME=${lName}&MMERGE9=${phone}&MMERGE7=${company}&MMERGE8=${company}&group[33792][1]=true`;

  jsonp(URL, { param: 'c' });
}
